"use client";

import Link from "next/link";
import { useTranslation } from "react-i18next";
import Logo from "./Logo";
import NewsletterForm from "./NewsletterForm";
import ThemeToggle from "./ThemeToggle";
import LanguageSwitcher from "./LanguageSwitcher";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="py-16 border-t border-border">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mb-12">
          <div>
            <Logo className="h-8 w-auto mb-4" />
            <p className="text-sm text-muted-foreground max-w-sm">
              {t("footer.description")}
            </p>
          </div>
          <div>
            <h3 className="font-heading font-semibold text-sm mb-3">{t("footer.newsletterTitle")}</h3>
            <NewsletterForm variant="compact" />
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between gap-6 pt-8 border-t border-border">
          <div className="flex items-center gap-6 text-sm text-muted-foreground flex-wrap justify-center">
            <Link href="/blog" className="hover:text-foreground transition-colors">{t("footer.blog")}</Link>
            <a href="#" className="hover:text-foreground transition-colors">{t("footer.privacy")}</a>
            <a href="#" className="hover:text-foreground transition-colors">{t("footer.terms")}</a>
            <a href="#" className="hover:text-foreground transition-colors">{t("footer.contact")}</a>
            <a href="#" className="hover:text-foreground transition-colors">{t("footer.linkedin")}</a>
          </div>
          <div className="flex items-center gap-4">
            <LanguageSwitcher />
            <ThemeToggle />
            <p className="text-xs text-muted-foreground">
              {t("footer.copyright", { year: new Date().getFullYear() })}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
